import React from "react";
import { useReportContext } from "./ReportContext";
import { IReportElement, IReportSlide } from "./ReprortContextTypes";
import slideContext, { useSlideContext } from "./SlideContext";
import { DataElement } from "./types";
import { createUUID } from "./utils";

const SlideContextProvider = slideContext.Provider;

const Text = (props: React.PropsWithChildren<{ slideElement: string }>) => {
  const slide = useSlideContext();

  const currentSlide = React.useRef<IReportSlide>({
    uuid: `${createUUID()}`,
    isReady: false,
    elements: [],
    addElement: (newElement) => {
      currentSlide.current.elements?.push(newElement);
      element.current?.children?.push(newElement);
    },
    onElementReady: (newElement) => {
      newElement.isReady = true;
      currentSlide.current?.checkReadiness?.();
    },
    checkReadiness: () => {
      const slide = currentSlide.current;
      if (slide) {
        if (!slide.isReady && slide.hasRenderedAtLeastOnce) {
          const readyCnt =
            slide.elements?.filter((el) => el.isReady).length || 0;
          const allCnt = slide.elements?.length || 0;
          if (readyCnt === allCnt) {
            slide.isReady = true;
            /*
                Table row is ready
            */
            // Here, make a copy of the element definition

            if (
              element.current.elementDefinition &&
              element.current?.children
            ) {
              const children = element.current?.children;
              const renderedElement = JSON.parse(
                JSON.stringify(element.current.elementDefinition)
              ) as DataElement;
              if (renderedElement.paragraphs) {
                children.forEach((ch) => {
                  const paraIndex = ch.paragraphIndex || 0;
                  const portIndex = ch.portionIndex || 0;
                  const portion =
                    renderedElement.paragraphs?.[paraIndex]?.portions?.[
                      portIndex
                    ];
                  if (portion) {
                    portion.text = ch.text || "";
                    // TODO: add font color etc.
                  }
                });
              }
              renderedElement.slideElement = renderedElement.tag;
              element.current.rendered = renderedElement;
            }
            if (slide) {
              slide?.onElementReady?.(element.current);
            }
          }
        }
      }
    },
  });

  // TODO: after rendering the element fetch the text data from inside of it
  const ref = React.useRef<HTMLDivElement>(null);
  const element = React.useRef<IReportElement>({
    isReady: false,
    type: "text",
    text: "",
    children: [],
    slideElement: props.slideElement,
    elementDefinition: slide!.slideDefinition?.elements
      .filter((el) => el.tag === props.slideElement)
      .pop(),
  });
  const report = useReportContext();
  React.useEffect(() => {
    slide?.addElement?.(element.current);
    currentSlide.current.hasRenderedAtLeastOnce = true;
    currentSlide.current.checkReadiness?.();
  }, [ref, report]);

  console.log("slide elementDefinition", element.current.elementDefinition);

  return (
    <div ref={ref}>
      <SlideContextProvider value={currentSlide.current}>
        {props.children}
      </SlideContextProvider>
    </div>
  );
};

export default Text;
